import React, { useState } from 'react';

export default function ScriptGenerator({ data }) {
  const [copied, setCopied] = useState(false);

  if (!data) {
    return <div className="script-generator"><p>No script available</p></div>;
  }

  // Fix: Use correct data path
  const script = data?.generatedContent?.fullScript || data?.script || 'No script generated';

  const handleCopy = () => {
    navigator.clipboard.writeText(script);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="script-generator">
      <div className="script-header">
        <h3>✍️ Video Script Outline</h3>
        <button className="copy-btn" onClick={handleCopy}>
          {copied ? '✅ Copied!' : '📋 Copy Script'}
        </button>
      </div>
      <div className="script-content">
        <pre>{script}</pre>
      </div>
    </div>
  );
}
